import { AddressType } from "../index.js";
export const getDeliveryAddress = (addresses) => {
    return addresses?.find((address) => address.type === AddressType.DELIVERY);
};
